import TemplateView from '../../../../js/TemplateView'
import {ICalTabType} from '../constants'
import messageResource from '../../../../js/messageResource'
import Button from '../../../../js/components/Button'
import {connect} from '../../../../js/redux/utils'
import {getActiveTab, isTopButtonsShown} from '../selectors'
import {changeActiveTab} from '../actions'
import {bindActionCreators} from 'redux'
import Tab from '../../../../js/components/Tab'
import SimpleDiv from '../../../../js/components/SimpleDiv'

class HeaderPanel extends TemplateView {
    constructor({
        changeActiveTab,
        onCreateButtonClick,
        onExportButtonClick,
    }) {
        super()

        this.callbacks = {
            changeActiveTab,
            onCreateButtonClick,
            onExportButtonClick,
        }

        this.state = {
            activeTab: ICalTabType.USER_FEEDS,
            showButtons: false,
        }

        this.onStatePropertyChanged('activeTab', activeTab => {
            this.allFeedsTab.setState({active: activeTab === ICalTabType.ALL_FEEDS})
            this.sharedFeedsTab.setState({active: activeTab === ICalTabType.USER_FEEDS})
        })

        this.onStatePropertyChanged('showButtons', showButtons => this.$buttonsArea.toggle(showButtons))
    }

    templateHtml() {
        return `<div class='headerPanel'>
                    <div class='tabsPanel'/>
                     <div class='buttonsArea'>
                        <div class='button createButton'/>
                        <div class='button exportButton'/>
                    </div>
                </div>`
    }

    afterRender() {
        const $tabsPanel = this.find('.tabsPanel')

        this.allFeedsTab = new Tab({
            text: messageResource.getMessage('icalendar.page.tab.all'),
            onClick: () => this.callbacks.changeActiveTab(ICalTabType.ALL_FEEDS),
        }).init($tabsPanel)

        new SimpleDiv({additionalClass: 'tabSeparator'}).init($tabsPanel)

        this.sharedFeedsTab = new Tab({
            text: messageResource.getMessage('icalendar.page.tab.user'),
            onClick: () => this.callbacks.changeActiveTab(ICalTabType.USER_FEEDS),
        }).init($tabsPanel)

        this.$buttonsArea = this.find('.buttonsArea')

        this.createButton = new Button({
            label: messageResource.getMessage('icalendar.page.buttons.create'),
            withPlusIcon: true,
            onClickCb: this.callbacks.onCreateButtonClick,
        }).init(this.find('.createButton'))

        this.exportButton = new Button({
            label: messageResource.getMessage('icalendar.page.buttons.export.short'),
            withPlusIcon: true,
            onClickCb: this.callbacks.onExportButtonClick,
        }).init(this.find('.exportButton'))
    }
}

export default connect(
    state => ({
        activeTab: getActiveTab(state),
        showButtons: isTopButtonsShown(state),
    }),
    dispatch => bindActionCreators({
        changeActiveTab,
    }, dispatch)
)(HeaderPanel)



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/HeaderPanel.js